import Container from '@/components/Container';
import LinkSafe from '@/components/LinkSafe';
import Section from '@/components/Section';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { mypageMenu } from '@/page-blocks/mypage/MypageCommon';
import { useUserStore } from '@/stores/UserStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';

const MenuSection = styled(Section)`
  border-bottom: 3px solid #e5e6e8;
  ${Container} {
    padding: 0;
  }
`;
const MainMenu = styled.div``;
const MainMenuList = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const MainMenuInner = styled.div`
  display: flex;
  ${breakpoint(800)} {
    min-width: max-content;
  }
`;
const MainMenuItem = styled.div<{ active?: boolean }>`
  flex: 1;
  min-width: 0;
  height: 80px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #b7b8ba;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  white-space: nowrap;
  transition: color 0.15s ease-in-out;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background-color: transparent;
    position: absolute;
    left: 0;
    bottom: -3px;
    transition: background-color 0.15s ease-in-out;
  }
  ${breakpoint(640)} {
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    flex: 0 0 auto;
    padding: 0 16px;
  }
  &:hover {
    color: #1cabe2;
    &::before {
      background-color: #1cabe2;
    }
  }
  ${({ active }) => {
    if (active) {
      return `
            color: #1cabe2;
            &::before {
              background-color: #1cabe2;
            }
          `;
    }
    return ``;
  }}
  a {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .receipt-menu {
    background-color: #1cabe2;
    width: 5px;
    height: 5px;
    border-radius: 75px;
    margin-left: 3px;
  }
`;

interface MypageRoutesProps {
  currentKey: number;
}

const MypageRoutes: FC<MypageRoutesProps> = observer(({ currentKey }) => {
  const userStore = useUserStore();
  const activeRef = useRef<HTMLDivElement>(null);

  // 발송현황 필터링
  const menus = useMemo(() => {
    if (userStore.user?.isRewardYn !== `Y`) {
      return mypageMenu.filter((menu) => menu.id !== 6);
    }
    return mypageMenu;
  }, [userStore.user?.isRewardYn]);

  // 현재 활성 메뉴가 보이도록 스크롤
  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({
        behavior: `smooth`,
        block: `nearest`,
        inline: `center`,
      });
    }
  }, [currentKey]);

  return (
    <MenuSection>
      <Container>
        <MainMenu>
          <MainMenuList>
            <MainMenuInner>
              {menus.map((routes) => (
                <MainMenuItem
                  key={routes.id}
                  active={currentKey === routes.id}
                  ref={currentKey === routes.id ? activeRef : undefined}
                >
                  <LinkSafe to={routes.link}>
                    {routes.name}
                    {routes.name === `기부금 영수증` && (
                      <div className="receipt-menu" />
                    )}
                  </LinkSafe>
                </MainMenuItem>
              ))}
            </MainMenuInner>
          </MainMenuList>
        </MainMenu>
      </Container>
    </MenuSection>
  );
});
export default MypageRoutes;
